// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"a44a4d32","240":"7cdd2afc","241":"76bd5cd4","300":"8beb54fb","382":"8fdef855","395":"7ac4d6c3","570":"866fa1be","617":"e9e1af8d","649":"89431946","960":"eada4c27"}[chunkId] + ".chunk.js";
};